import sagas from './sagas';
import reducer from './reducer';
import routes from './routes';

const addModule = {
  routes,
  sagas,
  reducer,
};
export default addModule;
